// extracted by mini-css-extract-plugin
export default {"doNotMoveButton":"MoveSeriesModal-doNotMoveButton-ZGp1h Button-button-paJ9a Link-link-RInnp"};